'use client'
import type { Data } from '@repo/strapi-types'
import { useTranslations } from 'next-intl'
import AppLink from '@/components/elementary/AppLink'
import { ArrowRight } from '@/components/icons/ArrowRight'
import { BasicImage } from '@/components/page-builder/components/BasicImage'
import Heading from '@/components/typography/Heading'
import { Paragraph } from '@/components/typography/Paragraph'
import { CASE_STUDIES_FILTERS_TEST_IDS } from '@/lib/test-ids'
import { getCaseStudyLink } from '@/utils/links'

export function CaseStudyCard(props: {
	slug: string | null | undefined
	title: string | null | undefined
	primaryImage: Data.Component<'utilities.basic-image'> | null | undefined
	previewImage: Data.Component<'utilities.basic-image'> | null | undefined
	brandTitle: string | null | undefined
}) {
	const { slug, title, primaryImage, previewImage, brandTitle } = props
	const t = useTranslations('CaseStudyCard')

	return (
		<div className="flex flex-col gap-4 flex-1">
			{primaryImage || previewImage ? (
				<div className="relative h-67.25 w-full rounded-xl border border-brand-black overflow-hidden">
					<BasicImage component={previewImage ?? primaryImage} fill className="object-cover" />
				</div>
			) : null}
			<Paragraph fontSize="bodyRegularLarge" textColor="black">
				{brandTitle}
			</Paragraph>
			<Heading tag="h3" fontSize="headingMedium">
				{title}
			</Heading>
			<AppLink
				href={getCaseStudyLink(slug)}
				variant="tertiaryLink"
				className="no-underline font-semibold w-fit"
				data-test-id={CASE_STUDIES_FILTERS_TEST_IDS.CASE_STUDY_LINK}
				iconEnd={<ArrowRight className="size-5" />}
			>
				{t('readStory')} <span className="sr-only">{title}</span>
			</AppLink>
		</div>
	)
}
